import React from 'react';

const TextAreaField = ({
  input,
  label,
  type,
  description,
  disabled,
  meta: { touched, error }
}) => (
  <div className="form-group mb-2">
    <textarea
      className="form-control"
      {...input}
      type={type}
      step="any"
      disabled={disabled}
      placeholder={label}
    />
    <span className="input-description">{description}</span>
    <div>
      {touched && (error && <span className="text-danger">{error}</span>)}
    </div>
  </div>
);

export default TextAreaField;



// WEBPACK FOOTER //
// ./src/components/common/TextAreaField.js